import { Mail, Phone, type LucideIcon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";


const icons = {
  mail: Mail,
  phone: Phone,
} as const;

export interface CopyAbleChipProps {
  text: string;
  href: string;
  icon: keyof typeof icons;
  copiedLabel?: string;
}

export function CopyAbleChip({
  text,
  href,
  icon,
  copiedLabel = "Skopiowano",
}: CopyAbleChipProps) {
  const Icon: LucideIcon = icons[icon];
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    toast.success(copiedLabel);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div
      className={`flex gap-4 items-center rounded-full w-72 transition-colors duration-300 ease-in-out cursor-pointer ${
        isCopied
          ? "bg-green-700 hover:bg-green-700"
          : "bg-background hover:bg-gray-700"
      }`}
      onClick={handleCopy}
      onKeyDown={event => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleCopy();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={href}
    >
      <div
        className={`w-10 h-10 rounded-full flex items-center justify-center ${
          isCopied ? "bg-green-300/20" : "bg-blue-300/20"
        }`}
      >
        <Icon size={18} />
      </div>
      {isCopied ? copiedLabel : text}
    </div>
  );
}
